import type { IDocument } from '@/models/document'
import { Document } from '@/models/document'
import documentService from '@/services/document/document'
import { defineStore } from 'pinia'
import type { IDocumentState } from './document.types'

export const useDocumentStore = defineStore('document', {
  state: (): IDocumentState => ({
    documents: []
  }),
  
  getters: {
    getDocuments(state: IDocumentState): IDocument[] {
      return state.documents.map((document) => new Document(document))
    }
  },

  actions: {
    async fetchDocuments() {
      const documents = await documentService.fetchDocuments()
      this.documents = documents
    }
  }
})
